import React from "react";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";


const BackdropLoading = () => {
	return (
		<Backdrop sx={theme => ({ zIndex: theme.zIndex.drawer + 1, color: "#fff" })} open={true}>
			<CircularProgress color="inherit" />
		</Backdrop>
	);
};

export default BackdropLoading;
